$(document).ready(function() {
  $('.link').click(function()
    {
      if(!$(this).children().hasClass('active'))  {
        $('.link .polygon-hover').removeClass('active');
        $(this).children().addClass('active');
        $('.shops-map-box__content.showed').removeClass('showed').slideUp('fast');
        $('#box-' + $(this).attr('id').replace('a-', '')).addClass('showed').slideDown('fast');
        }
      return false;
    });

    /*var $bannerBar = $(".banner-search__bar--dropdown");

    $bannerBar.on("click", function() {
      $(this).parent().toggleClass("dropdown-active");
      if($(this).parent().hasClass("dropdown-active")) {
        $(this).find(".arrow").css("background-image", "url(images/arrow-white-up.svg)");
      } else {
        $(this).find(".arrow").css("background-image", "url(images/arrow-white-down.svg)");
      }
    });
    $(".banner-dropdown-content li a").on("click", function(e) {
      categoryBanner = $(this).text();
      $(this).closest(".banner-search__bar--dropdown")
             .find(".banner-pickBar").text(categoryBanner)
      $(this).closest(".banner-search__bar").removeClass("dropdown-active");
      $(".arrow").css("background-image", "url(images/arrow-white-down.svg)");
      return false;
    });*/
  //shop active/inactive menu head
  ///////////////////////////////
  $(".shops-list__clickable").on("click", function(e) {
    e.preventDefault();
    $(".shops-list__clickable").removeClass("active");
    $(this).addClass("active");
  });

  $(".shops-floor a").on("click", function(e) {
    e.preventDefault();
    $(".shops-floor a").removeClass("shops-floor-active");
    $(this).addClass("shops-floor-active");
  });

  $("#shop-list").on("click", function(e) {
    e.preventDefault();
    $(".shops-map").hide();
    $(".shops-container").fadeIn();
  });
  $("#shop-map").on("click", function(e) {
    e.preventDefault();
    $(".shops-container").hide();
    $(".shops-map").fadeIn();
  });

  $(".shops-element-info").hide();
  //shops slide down elements
  /////////////////////////////////
  $(".shops-element-content__logo").on("click", function() {
    $(".shops-element-map").slideUp();
    $(this).closest(".shops-element").find(".shops-element-info").slideToggle().css("display", "flex");
  });
  $(".shops-element-content__level").on("click", function() {
    $(".shops-element-info").slideUp();
    $(this).closest(".shops-element").find(".shops-element-map").slideToggle().css("display", "flex");
  });
  //home dropdown
  //////////////////////////////
  var $searchBar = $(".home-search__bar--dropdown");

  $searchBar.on("click", function() {
    $(this).parent().toggleClass("dropdown-active");
    if($(this).parent().hasClass("dropdown-active")) {
      $(this).find(".pickBar").css("background-image", "url(images/home-arrow2.svg)");
    } else {
      $(this).find(".pickBar").css("background-image", "url(images/home-arrow.svg)");
    }
  });
  $(".dropdown-content li a").on("click", function(e) {
    category = $(this).text();
    $(this).closest(".home-search__bar--dropdown")
           .find(".pickBar").text(category)
           .css("background-image", "url(images/home-arrow.svg)");
    $(this).closest(".home-search__bar").removeClass("dropdown-active");
    return false;
  });
  //banner dropdown
  ////////////////////////
  var $bannerBar = $(".banner-search__bar--dropdown");

  $bannerBar.on("click", function() {
    $(this).parent().toggleClass("dropdown-active");
    if($(this).parent().hasClass("dropdown-active")) {
      $(this).find(".arrow").css("background-image", "url(images/arrow-white-up.svg)");
    } else {
      $(this).find(".arrow").css("background-image", "url(images/arrow-white-down.svg)");
    }
  });
  $(".banner-dropdown-content li a").on("click", function(e) {
    categoryBanner = $(this).text();
    $(this).closest(".banner-search__bar--dropdown")
           .find(".banner-pickBar").text(categoryBanner)
    $(this).closest(".banner-search__bar").removeClass("dropdown-active");
    $(".arrow").css("background-image", "url(images/arrow-white-down.svg)");
    return false;
  });

  //news mouse enter
  $(".news-element").on("mouseenter", function() {
    $(this).find(".news-element-top-text").fadeIn();
    $(this).find(".news-element-top-heading").fadeIn();
    $(this).find(".news-element-bottom-nonhover").hide();
    $(this).find(".news-element-bottom-hover").fadeIn();
  });
  $(".news-element").on("mouseleave", function() {
    $(".news-element-top-heading").hide();
    $(".news-element-top-text").hide();
    $(".news-element-bottom-nonhover").show();
    $(".news-element-bottom-hover").hide();
  });
  //////////////////////////////
  //menu
  $("#hamburger-container").on("click", function() {
    $("#header").toggleClass("header-active");
    $(".menu-button-bar1").toggleClass("animate1");
    $(".menu-button-bar2").toggleClass("animate2");
    $(".menu-button-bar3").toggleClass("animate3");
  });
  // scoroll on a/*
  if(window.matchMedia("(min-width: 1500px)").matches) {
      $("a").on("click", function() {
        if ($(this).attr("href")) {
        $("html, body").animate({
          scrollTop: $( $(this).attr("href")).offset().top - 120
        }, 800);
        }
      })
  } else if (window.matchMedia("(min-width: 500px)").matches) {
      $("a").on("click", function() {
        if ($(this).attr("href")) {
        $("html, body").animate({
          scrollTop: $( $(this).attr("href")).offset().top - 100
        }, 800);
        }
      })

  } else {
      $("a").on("click", function() {
        if ($(this).attr("href")) {
        $("html, body").animate({
          scrollTop: $( $(this).attr("href")).offset().top - 60
        }, 800);
        }
      })

  }
 ////////////////////////////////////

  var mySwiper = new Swiper ('.slider.swiper-container', {
      direction: 'vertical',
      loop: true,
      autoplay: 7000,
      speed: 500,
      pagination: '.swiper-pagination',
      slidesPerView: 1,
      paginationClickable: true,
      grabCursor: true,
      breakpoints: {
          1050: {
            direction: 'horizontal',
            slidesPerView: 1,
          }
        }
  });


  if(window.matchMedia("(min-width: 1050px)").matches) {
  $(".header__nav ul li").on("mouseenter", function() {
    $(".header__nav ul li a.underline-active").addClass("current-active");
    $(".header__nav ul li a.underline-active").removeClass("underline-active");
  });
  $(".header__nav   ").on("mouseleave", function() {
    $(".header__nav ul li a.current-active").addClass("underline-active");
    $(".header__nav ul li a.current-active").removeClass("current-active");
  });

  $(".header__nav ul li a").on("mouseenter", function() {
    $(this).addClass("current-active2");
  });
  $(".header__nav ul li a").on("mouseleave", function() {
    $(".header__nav ul li a").removeClass("current-active2");
  });
  }

  $(window).on("scroll", function() {
    var scroll = $(window).scrollTop();

    if (scroll > 50) {
      $("#header").addClass("header-fixed");
    } else {
      $("#header").removeClass("header-fixed");
    }
  });

  $(window).on("load",function()
  {
    if ($(window).width() > 1200 && $('#count').val() == 'false')
        {
        $('#count').val('true');

        $('.count').each(function ()
          {
            $(this).prop('Counter',0).animate({
              Counter: $(this).text()
            }, {
                duration: 5000,
                easing: 'swing',
                    step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });
     }
  });
  jQuery('img.svg').each(function(){
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = jQuery(data).find('svg');

          // Add replaced image's ID to the new SVG
          if(typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if(typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass+' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Replace image with new SVG
          $img.replaceWith($svg);

      }, 'xml');

  });
});
  // svg

        ////////////////
        $(document).ready(function() {
          if(window.matchMedia("(min-width: 1500px)").matches) {
              $('html, body').hide();

              if (window.location.hash) {
                  setTimeout(function() {
                      $('html, body').show().scrollTop(0);
                      $('html, body').animate({
                          scrollTop: $(window.location.hash).offset().top - 100
                          }, 1000)
                  }, 0);
              }
              else {
                  $('html, body').show();
              }
          } else if (window.matchMedia("(min-width: 500px)").matches) {
            $('html, body').hide();

            if (window.location.hash) {
                setTimeout(function() {
                    $('html, body').show().scrollTop(0);
                    $('html, body').animate({
                        scrollTop: $(window.location.hash).offset().top - 80
                        }, 1000)
                }, 0);
            }
            else {
                $('html, body').show();
            }
          } else {
            $('html, body').hide();

            if (window.location.hash) {
                setTimeout(function() {
                    $('html, body').show().scrollTop(0);
                    $('html, body').animate({
                        scrollTop: $(window.location.hash).offset().top - 60
                        }, 1000)
                }, 0);
            }
            else {
                $('html, body').show();
            }
          }
        });
